import _ from 'lodash';

import { urlToImageFile } from '../other';

export const normalizeAccountExport = async (
  accountWorkSheet,
  accountData,
  brokerData,
  agencyData,
  workbook,
) => {
  accountWorkSheet.views = [{ showGridLines: false }];

  // ---------------------------
  // 1. Header Section
  // ---------------------------

  const rowTitle = accountWorkSheet.addRow([]);
  accountWorkSheet.mergeCells('A1:B1');
  rowTitle.getCell(1).value = 'MonarkHQ';
  accountWorkSheet.addRow([]);

  let row = accountWorkSheet.addRow([
    `Group Insurance Report \r\nPresented to: ${accountData?.company_name}`,
  ]);
  row.getCell(1).alignment = { wrapText: true, horizontal: 'left', vertical: 'top' };
  row.height = 50;
  accountWorkSheet.mergeCells('A3:J3');
  row.font = { name: 'Calibri', size: 18, bold: true };

  accountWorkSheet.addRow([]);
  accountWorkSheet.addRow([]);

  row = accountWorkSheet.addRow([`Company Name: ${accountData?.company_name}`]);
  accountWorkSheet.mergeCells('A6:J6');
  row.font = { name: 'Calibri', size: 16, bold: true };
  row.alignment = { horizontal: 'left', vertical: 'top' };

  accountWorkSheet.addRow([]);
  row = accountWorkSheet.addRow([]);
  accountWorkSheet.mergeCells('A8:J8');
  row.getCell(6).value = `Effective Date: ${accountData?.effective_date}`;
  row.alignment = { horizontal: 'right', vertical: 'top' };

  for (let rowNum = 1; rowNum <= 8; rowNum++) {
    let currentRow = accountWorkSheet.getRow(rowNum);
    for (let colNum = 1; colNum <= 10; colNum++) {
      let cell = currentRow.getCell(colNum);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '7b61ff' },
      };

      if (cell.font) {
        cell.font.color = { argb: 'FFFFFFFF' };
      } else {
        cell.font = { color: { argb: 'FFFFFFFF' } };
      }
    }
  }

  // ---------------------------
  // 2. Created By Section
  // ----------------------------

  accountWorkSheet.addRow([]);
  accountWorkSheet.addRow([]);

  const startBrokerIndex = accountWorkSheet.lastRow.number;

  row = accountWorkSheet.addRow(['Broker']);
  row.font = { name: 'Calibri', size: 14, bold: true };
  row.alignment = { horizontal: 'left', vertical: 'top' };
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );

  accountWorkSheet.addRow([]);

  row = accountWorkSheet.addRow([`Full Name: ${brokerData?.display_name}`]);
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  row = accountWorkSheet.addRow([`Phone: ${brokerData?.phone_number}`]);
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  row = accountWorkSheet.addRow([`Email: ${brokerData?.email}`]);
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  row = accountWorkSheet.addRow([
    `Address: ${brokerData?.address_street}, ${brokerData?.address_city}, ${brokerData?.address_state}, ${brokerData?.address_zip_code}`,
  ]);
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  accountWorkSheet.addRow([]);

  const endBrokerIndex = accountWorkSheet.lastRow.number;

  for (let rowNum = startBrokerIndex; rowNum <= endBrokerIndex; rowNum++) {
    let currentRow = accountWorkSheet.getRow(rowNum);
    for (let colNum = 1; colNum <= 10; colNum++) {
      let cell = currentRow.getCell(colNum);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1a1a40' },
      };

      if (cell.font) {
        cell.font.color = { argb: 'FFFFFFFF' };
      } else {
        cell.font = { color: { argb: 'FFFFFFFF' } };
      }
    }
  }

  // ---------------------------
  // 4. Contacts Section
  // ---------------------------

  const primaryContact = accountData?.contacts?.find((item) => item.contact_type === 'primary');

  accountWorkSheet.addRow([]);
  accountWorkSheet.addRow([]);

  const startContactsIndex = accountWorkSheet.lastRow.number;

  row = accountWorkSheet.addRow(['Primary Contact']);
  row.alignment = { wrapText: true, horizontal: 'left', vertical: 'top' };
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );

  accountWorkSheet.addRow([]);
  row.font = { name: 'Calibri', size: 14, bold: true };

  row = accountWorkSheet.addRow([]);

  const charsPerLine = 40;
  // approximate height of one line in points (Calibri 12 ≈ 14.4pt)
  const lineHeight = 16;

  const address = `Address: ${accountData?.address_street}, ${accountData?.address_city}, ${accountData?.address_state}, ${accountData?.address_zip_code}`;

  row.getCell(1).value = address;
  row.alignment = { wrapText: true, horizontal: 'left', vertical: 'top' };
  row.getCell(6).value = `Email: ${primaryContact?.email}`;
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:D${accountWorkSheet.lastRow.number}`,
  );
  accountWorkSheet.mergeCells(
    `F${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  const lines = Math.ceil(address.length / charsPerLine);
  row.height = lines * lineHeight;

  row = accountWorkSheet.addRow([]);
  row.getCell(1).value = `Contact: ${primaryContact?.name}`;
  row.getCell(6).value = `Phone: ${accountData?.contact_phone}`;
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:D${accountWorkSheet.lastRow.number}`,
  );
  accountWorkSheet.mergeCells(
    `F${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  row = accountWorkSheet.addRow([]);
  row.getCell(1).value = `SIC Code: ${accountData?.sic_code}`;
  row.getCell(6).value = `Fips Code: ${accountData?.fips_code}`;
  accountWorkSheet.mergeCells(
    `A${accountWorkSheet.lastRow.number}:D${accountWorkSheet.lastRow.number}`,
  );
  accountWorkSheet.mergeCells(
    `F${accountWorkSheet.lastRow.number}:J${accountWorkSheet.lastRow.number}`,
  );
  row.font = { name: 'Calibri', size: 12 };

  accountWorkSheet.addRow([]);
  const endContactsIndex = accountWorkSheet.lastRow.number;

  for (let rowNum = startContactsIndex; rowNum <= endContactsIndex; rowNum++) {
    let currentRow = accountWorkSheet.getRow(rowNum);
    for (let colNum = 1; colNum <= 10; colNum++) {
      let cell = currentRow.getCell(colNum);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1a1a40' },
      };

      if (cell.font) {
        cell.font.color = { argb: 'FFFFFFFF' };
      } else {
        cell.font = { color: { argb: 'FFFFFFFF' } };
      }
    }
  }

  const normalizedBrokerPhoto = !_.isEmpty(agencyData)
    ? agencyData.logo_url
    : brokerData?.photo_url;

  const agency_image = await urlToImageFile(normalizedBrokerPhoto);
  const agency_image_id = workbook.addImage({
    base64: agency_image,
    extension: 'jpeg',
  });
  accountWorkSheet.addImage(agency_image_id, {
    tl: { col: 8, row: 11 },
    ext: { width: 100, height: 100 },
  });

  const account_image = await urlToImageFile(accountData.logo_url);
  const account_image_id = workbook.addImage({
    base64: account_image,
    extension: 'jpeg',
  });

  accountWorkSheet.addImage(account_image_id, {
    tl: { col: 8, row: 2 },
    ext: { width: 100, height: 100 },
  });

  for (let rowIndex = 1; rowIndex <= accountWorkSheet.rowCount; rowIndex++) {
    let currentRow = accountWorkSheet.getRow(rowIndex);
    currentRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.alignment = { horizontal: 'left', vertical: 'top', wrapText: true };
    });
  }
};
